export { SmallCarousel, LargeCarousel, LargeStyledArrow } from './Carousel';
